import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleMouseEnter = () => {
        setDropdownOpen(true);
    };

    const handleMouseLeave = () => {
        setDropdownOpen(false);
    };

    return (
        <nav
            className="sticky z-10 w-full self-stretch p-4 bg-secondary shadow-[0px_5px_5px_0px_rgba(109,109,109,0.25)] inline-flex flex-col justify-start items-center gap-2"
            id="Nav">
            <div className="flex flex-col justify-center items-center gap-1">
                <div
                    className="justify-start text-primary text-3xl md:text-6xl font-normal font-playfair-display">Lumi Glass</div>
                <div
                    className="justify-start text-primary text-sm md:text-base font-medium font-playfair-display tracking-[4.64px] md:tracking-[9.28px]">
                    Your Vison, Our Glass Solutions
                </div>
                <div
                    className="justify-start text-primary text-sm md:text-lg font-light font-playfair-display tracking-[2.32px] md:tracking-[4.64px]">
                    Partnered with Bob's Glass Works
                </div>
            </div>
            <div
                className="self-stretch py-2 md:py-4 inline-flex justify-center items-center gap-2 md:gap-6">
                <motion.div
                    whileHover={{
                        scale: 1.05
                    }}
                    transition={{
                        duration: 0.3
                    }}>
                    <Link
                        to="/"
                        className="justify-start text-primary hover:text-accent hover:underline hover:decoration-accent text-base md:text-lg font-normal font-nunito-sans transition duration-300">
                        Home
                    </Link>
                </motion.div>
                <motion.div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    whileHover={{
                        scale: 1.05
                    }}
                    transition={{
                        duration: 0.3
                    }}
                    className="relative"
                >
                    <button
                        className="justify-start text-primary hover:text-accent hover:underline hover:decoration-accent text-base md:text-lg font-normal font-nunito-sans transition duration-300">
                        Services
                    </button>
                    <div className={`absolute top-full left-0 ${dropdownOpen ? 'block' : 'hidden'}`}>
                        <div className="w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                            <div className="py-1" role="none">
                                <Link
                                    to="/services/auto"
                                    className="text-gray-700 block px-4 py-2 text-sm hover:bg-primary hover:text-accent" role="menuitem" tabindex="-1" id="menu-item-0">Automotive</Link>
                                <Link
                                    to="/services/residential"
                                    className="text-gray-700 block px-4 py-2 text-sm hover:bg-primary hover:text-accent" role="menuitem" tabindex="-1" id="menu-item-1">Residential</Link>
                                <Link
                                    to="/services/commercial"
                                    className="text-gray-700 block px-4 py-2 text-sm hover:bg-primary hover:text-accent" role="menuitem" tabindex="-1" id="menu-item-2">Commercial</Link>
                            </div>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    whileHover={{
                        scale: 1.05
                    }}
                    transition={{
                        duration: 0.3
                    }}>
                    <Link
                        to="services/service_home"
                        className="justify-start text-primary hover:text-accent hover:underline hover:decoration-accent text-base md:text-lg font-normal font-nunito-sans transition duration-300">
                        About
                    </Link>
                </motion.div>

                <motion.div
                    whileHover={{
                        scale: 1.05
                    }}
                    transition={{
                        duration: 0.3
                    }}>
                    <Link
                        to="/contact"
                        className="justify-start text-primary hover:text-accent hover:underline hover:delection-accent text-base md:text-lg font-normal font-nunito-sans transition duration-300">
                        Contact
                    </Link>

                </motion.div>
            
            </div>
        </nav>
    );
};

export default Navbar;
